import React, { useState, useEffect } from "react";
import Logo from "../../components/logo";
import LanguageSwitcher from "../../components/languageSwitcher";
import { ReactComponent as TwitterIcon } from "../../assets/twitter.svg";
import { ReactComponent as InstagramIcon } from "../../assets/instagram.svg";
import { ReactComponent as FacebookIcon } from "../../assets/facebook.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/linkedin.svg";
import { Link } from "react-router-dom";
import ThemeToggle from "../../components/themeToggle";
import { useAppContext } from "../../context";

const tabs = [
  { id: "social", label: "Social Crowdfunding" },
  { id: "ikimina", label: "IKIMINA" },
  { id: "usave", label: "U-Save" },
  // { id: "uinvest", label: "U-Invest" },
];

function App() {
  const [activeTab, setActiveTab] = useState("social");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const { isDarkMode } = useAppContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);

  // Update the active tab based on the URL hash on page load
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (tabs.some((tab) => tab.id === hash)) {
      setActiveTab(hash);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarVisible(false);
      } else {
        setIsSidebarVisible(true);
      }
    };

    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Update the URL hash when the active tab changes
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    window.location.hash = tabId;
    setIsMenuOpen(false); // Close the menu on tab change
  };

  const renderContent = () => {
    switch (activeTab) {
      case "ikimina":
        return (
          <>
            <h1 className="text-2xl font-semibold  mb-4">
              Terms & Conditions for Group Savings (Ikimina)
            </h1>
            <p className="text-sm text-gray-500 mb-6">
              Effective Date: 03-04-2025
            </p>

            <div className="space-y-6">
              {/* Acceptance of Terms */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  Acceptance of Terms
                </h2>
                <p className="text-sm">
                  By using Uplus’s Group Savings (Ikimina) product, you agree to
                  the following terms:
                </p>
              </section>

              {/* Eligibility */}
              <section>
                <h2 className="text-xl font-semibold mb-2">Eligibility</h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Users must be of legal age and provide accurate registration
                    details.
                  </li>
                  <li>
                    Groups must follow the rules set by Uplus for savings
                    management.
                  </li>
                </ul>
              </section>

              {/* Contributions and Withdrawals */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  Contributions and Withdrawals
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Group members must adhere to their agreed-upon savings
                    schedule.
                  </li>
                  <li>
                    Withdrawals require group authorisation and adherence to
                    group rules.
                  </li>
                </ul>
              </section>

              {/* Responsibilities of Users */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  Responsibilities of Users
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>Users must ensure the accuracy of their transactions.</li>
                  <li>
                    Fraudulent activities will lead to account suspension or
                    legal action.
                  </li>
                </ul>
              </section>

              {/* Fees and Charges */}
              <section>
                <h2 className="text-xl font-semibold mb-2">Fees and Charges</h2>
                <p className="text-sm">
                  Uplus may charge transaction fees as communicated on the
                  platform. Any changes to fees will be notified in advance.
                </p>
              </section>

              {/* Liability Disclaimer */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  Liability Disclaimer
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Uplus is not liable for internal group disputes or
                    mismanagement of funds by members.
                  </li>
                  <li>
                    Users are responsible for securing their login credentials.
                  </li>
                </ul>
              </section>

              {/* Amendments and Termination */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  Amendments and Termination
                </h2>
                <p className="text-sm">
                  Uplus reserves the right to modify these terms with prior
                  notice. Violations of these terms may result in account
                  suspension or termination.
                </p>
              </section>

              {/* Contact Information */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  Contact Information
                </h2>
                <p className="text-sm">
                  Uplus Mutual Partners Ltd
                  <br />
                  Kigali, Rwanda
                  <br />
                  Phone:{" "}
                  <a
                    href="tel:+250794776745"
                    className="text-blue-600 underline"
                  >
                    +250 794776745
                  </a>
                  <br />
                  Email:{" "}
                  <a
                    href="mailto:support@uplus.rw"
                    className="text-blue-600 underline"
                  >
                    support@uplus.rw
                  </a>
                </p>
              </section>
            </div>
          </>
        );
      case "usave":
        return (
          <>
            {/* Page Title */}
            <h1 className="text-2xl font-semibold  mb-4">
              U-SAVE TERMS AND CONDITIONS
            </h1>
            <p className="text-sm text-gray-500 mb-6">
              Effective Date: 03-04-2023
            </p>

            <div className="space-y-6">
              {/* 1. Introduction */}
              <section>
                <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
                <p className="text-sm">
                  U-Save is a savings product offered by Uplus that allows
                  customers to store their funds securely without earning
                  interest. By using U-Save, you agree to the following terms
                  and conditions. These terms govern your use of U-Save and
                  outline the rights and responsibilities of both the customer
                  and Uplus.
                </p>
              </section>

              {/* 2. Eligibility */}
              <section>
                <h2 className="text-xl font-semibold mb-2">2. Eligibility</h2>
                <ul className="list-disc list-inside text-sm">
                  <li>You must be a registered Uplus user.</li>
                  <li>
                    You must provide accurate and up-to-date information during
                    registration.
                  </li>
                  <li>
                    Users must be at least 18 years old or have
                    parental/guardian consent.
                  </li>
                  <li>
                    Uplus reserves the right to verify your identity at any
                    time.
                  </li>
                </ul>
              </section>

              {/* 3. Deposits and Withdrawals */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  3. Deposits and Withdrawals
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Customers can deposit funds into their U-Save account at any
                    time through approved Uplus deposit channels.
                  </li>
                  <li>
                    Withdrawals can be made per the withdrawal process outlined
                    by Uplus, which may include security verifications.
                  </li>
                  <li>
                    Withdrawals may be subject to transaction limits set by
                    Uplus.
                  </li>
                  <li>No interest is earned on funds saved in U-Save.</li>
                  <li>
                    Uplus reserves the right to set a minimum balance
                    requirement if necessary.
                  </li>
                </ul>
              </section>

              {/* 4. Fees and Charges */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  4. Fees and Charges
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Uplus reserves the right to apply transaction fees where
                    applicable, including but not limited to withdrawal and
                    service fees.
                  </li>
                  <li>
                    Any changes to fees will be communicated in advance via
                    official Uplus channels.
                  </li>
                  <li>
                    Users are responsible for reviewing and understanding the
                    applicable fees before using the service.
                  </li>
                </ul>
              </section>

              {/* 5. Security and Fraud Prevention */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  5. Security and Fraud Prevention
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Users must keep their account credentials, including
                    passwords and PINs, secure at all times.
                  </li>
                  <li>
                    Uplus implements security measures to protect user funds and
                    data but is not responsible for losses due to negligence in
                    securing account information.
                  </li>
                  <li>
                    Any suspicious activity should be reported immediately to
                    Uplus customer support.
                  </li>
                  <li>
                    Uplus reserves the right to suspend accounts involved in
                    suspected fraudulent activities pending investigation.
                  </li>
                </ul>
              </section>

              {/* 6. Account Termination */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  6. Account Termination
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Uplus reserves the right to terminate accounts that violate
                    these terms of service, engage in fraudulent activities, or
                    provide false information.
                  </li>
                  <li>
                    Users may request to close their U-Save account by
                    contacting Uplus customer support.
                  </li>
                  <li>
                    Upon termination, all funds in the account will be processed
                    per Uplus's closure policies and any outstanding obligations
                    must be settled.
                  </li>
                </ul>
              </section>

              {/* 7. Limitation of Liability */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  7. Limitation of Liability
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Uplus is not liable for losses due to system downtime,
                    cyberattacks, unauthorized access resulting from user
                    negligence, or force majeure events.
                  </li>
                  <li>
                    Uplus does not provide guarantees on the availability of the
                    U-Save service and reserves the right to suspend it for
                    maintenance or regulatory compliance.
                  </li>
                  <li>
                    Customers agree that Uplus will not be held responsible for
                    financial losses due to third-party actions.
                  </li>
                </ul>
              </section>

              {/* 8. Amendments */}
              <section>
                <h2 className="text-xl font-semibold mb-2">8. Amendments</h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Uplus reserves the right to modify these terms and
                    conditions with prior notice to users.
                  </li>
                  <li>
                    Continued use of U-Save after changes implies acceptance of
                    the updated terms.
                  </li>
                  <li>
                    Users are encouraged to review the terms periodically.
                  </li>
                </ul>
              </section>

              {/* 9. Contact Information */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  9. Contact Information
                </h2>
                <p className="text-sm">
                  For any inquiries, complaints, or support regarding U-Save,
                  please contact:
                </p>
                <p className="text-sm">
                  Email:{" "}
                  <a
                    href="mailto:support@uplus.com"
                    className="text-blue-600 underline"
                  >
                    support@uplus.com
                  </a>
                  <br />
                  Phone:{" "}
                  <a
                    href="tel:+250794776745"
                    className="text-blue-600 underline"
                  >
                    +250 794776745
                  </a>
                  <br />
                  Website:{" "}
                  <a
                    href="https://www.uplus.rw"
                    className="text-blue-600 underline"
                  >
                    www.uplus.rw
                  </a>
                </p>
              </section>
            </div>
          </>
        );

      case "uinvest":
        return (
          <>
            {/* Page Title */}
            <h1 className="text-2xl font-semibold  mb-4">
              U-Invest Terms and Conditions
            </h1>
            <p className="text-sm text-gray-500 mb-6">
              Effective Date: 03-04-2025
            </p>

            <div className="space-y-6">
              {/* 1. Acceptance of Terms */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  1. Acceptance of Terms
                </h2>
                <p className="text-sm">
                  By accessing or using the U-Invest service provided by Uplus
                  Mutual Partners Ltd, you agree to be bound by these Terms and
                  Conditions. Please read them carefully before proceeding.
                </p>
              </section>

              {/* 2. Fund Management */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  2. Fund Management
                </h2>
                <p className="text-sm">
                  U-Invest funds are managed by BK Capital. Uplus acts solely as
                  a facilitator of the investment process. All investment
                  decisions, returns, and management of funds are the
                  responsibility of BK Capital.
                </p>
              </section>

              {/* 3. Eligibility */}
              <section>
                <h2 className="text-xl font-semibold mb-2">3. Eligibility</h2>
                <p className="text-sm">
                  To use U-Invest, you must be at least 18 years old and provide
                  complete, accurate, and up-to-date personal information during
                  registration.
                </p>
              </section>

              {/* 4. Account Registration and Security */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  4. Account Registration and Security
                </h2>
                <p className="text-sm mb-2">
                  Users are required to create an account by providing all
                  necessary details. You are responsible for safeguarding your
                  account login credentials and for any activities under your
                  account. Always report any unauthorized activity.
                </p>
                <ul className="list-disc list-inside text-sm">
                  <li>Use a strong and unique password.</li>
                  <li>
                    Never share your password or security details with others.
                  </li>
                  <li>
                    Notify Uplus immediately if you suspect any breach of your
                    account.
                  </li>
                </ul>
              </section>

              {/* 5. Investment Terms and Risk Acknowledgment */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  5. Investment Terms and Risk Acknowledgment
                </h2>
                <p className="text-sm">
                  Investments through U-Invest are subject to market risks. You
                  acknowledge that the value of investments can fluctuate, and
                  past performance does not guarantee future returns.
                </p>
              </section>

              {/* 6. Privacy and Data Protection */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  6. Privacy and Data Protection
                </h2>
                <p className="text-sm">
                  All personal data collected is managed in accordance with our
                  Privacy Policy. Uplus is committed to protecting your
                  information and only using it for authorized purposes as
                  described in our policy.
                </p>
              </section>

              {/* 7. Prohibited Activities */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  7. Prohibited Activities
                </h2>
                <p className="text-sm">
                  Users are prohibited from engaging in fraudulent, abusive, or
                  illegal activities. Violation of these terms may result in
                  immediate account suspension or termination.
                </p>
              </section>

              {/* 8. Termination and Suspension */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  8. Termination and Suspension
                </h2>
                <p className="text-sm">
                  Uplus reserves the right to suspend or terminate your account
                  if you breach these Terms and Conditions, without prior
                  notice.
                </p>
              </section>

              {/* 9. Dispute Resolution */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  9. Dispute Resolution
                </h2>
                <p className="text-sm">
                  Any disputes arising out of or in connection with these Terms
                  and Conditions shall be resolved through binding arbitration
                  under the rules applicable in Rwanda.
                </p>
              </section>

              {/* 10. Amendments */}
              <section>
                <h2 className="text-xl font-semibold mb-2">10. Amendments</h2>
                <p className="text-sm">
                  Uplus reserves the right to amend these Terms and Conditions
                  at any time. Significant changes will be communicated to
                  users, and continued use of the service constitutes acceptance
                  of any updated terms.
                </p>
              </section>

              {/* 11. Contact Information */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  11. Contact Information
                </h2>
                <p className="text-sm">
                  For any questions regarding these Terms and Conditions, please
                  contact:
                  <br />
                  Email:{" "}
                  <a
                    href="mailto:support@uplus.com"
                    className="text-blue-600 underline"
                  >
                    support@uplus.com
                  </a>
                  <br />
                  Phone:{" "}
                  <a
                    href="tel:+250794776745"
                    className="text-blue-600 underline"
                  >
                    +250 794776745
                  </a>
                  <br />
                  Address: Kigali, Rwanda.
                </p>
              </section>
            </div>
          </>
        );
      default:
        return (
          <>
            <h1 className="text-2xl font-semibold  mb-4">
              Terms & Conditions for Social Crowdfunding Product
            </h1>
            <p className="text-sm text-gray-500 mb-6">
              Effective Date: 03-04-2025
            </p>

            <div className="space-y-6">
              {/* 1. Acceptance of Terms */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  1. Acceptance of Terms
                </h2>
                <p className="text-sm">
                  By using Uplus Social Crowdfunding, you agree to these Terms &
                  Conditions. If you do not agree, please do not use the
                  platform.
                </p>
              </section>

              {/* 2. Eligibility */}
              <section>
                <h2 className="text-xl font-semibold mb-2">2. Eligibility</h2>
                <p className="text-sm">
                  Users must be at least 18 years old and comply with applicable
                  laws to participate in crowdfunding activities.
                </p>
              </section>

              {/* 3. Account Registration */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  3. Account Registration
                </h2>
                <p className="text-sm">
                  Users must provide accurate information and are responsible
                  for maintaining the confidentiality of their login details.
                </p>
              </section>

              {/* 4. Crowdfunding Campaigns */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  4. Crowdfunding Campaigns
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Campaign creators are responsible for the accuracy of
                    campaign descriptions.
                  </li>
                  <li>Funds raised must be used for the stated purpose.</li>
                  <li>
                    Uplus is not responsible for campaign success or fund
                    utilisation.
                  </li>
                </ul>
              </section>

              {/* 5. Contributions and Withdrawals */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  5. Contributions and Withdrawals
                </h2>
                <ul className="list-disc list-inside text-sm">
                  <li>
                    Contributions are voluntary and non-refundable unless
                    otherwise specified.
                  </li>
                  <li>
                    Withdrawals are subject to verification and platform fees.
                  </li>
                </ul>
              </section>

              {/* 6. Prohibited Activities */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  6. Prohibited Activities
                </h2>
                <p className="text-sm mb-2">Users may not:</p>
                <ul className="list-disc list-inside text-sm">
                  <li>Engage in fraudulent or illegal activities.</li>
                  <li>
                    Use the platform for unauthorised financial transactions.
                  </li>
                  <li>Post false or misleading information.</li>
                </ul>
              </section>

              {/* 7. Fees and Charges */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  7. Fees and Charges
                </h2>
                <p className="text-sm">
                  Uplus may charge service fees for transactions, which will be
                  disclosed before processing payments.
                </p>
              </section>

              {/* 8. Limitation of Liability */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  8. Limitation of Liability
                </h2>
                <p className="text-sm">
                  Uplus is not liable for any losses, damages, or disputes
                  arising from campaigns or contributions made on the platform.
                </p>
              </section>

              {/* 9. Suspension and Termination */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  9. Suspension and Termination
                </h2>
                <p className="text-sm">
                  Uplus reserves the right to suspend or terminate accounts that
                  violate these terms or engage in suspicious activity.
                </p>
              </section>

              {/* 10. Governing Law */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  10. Governing Law
                </h2>
                <p className="text-sm">
                  These Terms & Conditions are governed by the laws of [Insert
                  Jurisdiction].
                </p>
              </section>

              {/* 11. Amendments */}
              <section>
                <h2 className="text-xl font-semibold mb-2">11. Amendments</h2>
                <p className="text-sm">
                  We may update these terms and will notify users of significant
                  changes.
                </p>
              </section>

              {/* 12. Contact Information */}
              <section>
                <h2 className="text-xl font-semibold mb-2">
                  12. Contact Information
                </h2>
                <p className="text-sm">
                  Uplus Mutual Partners Ltd
                  <br />
                  Kigali, Rwanda
                  <br />
                  Phone:{" "}
                  <a
                    href="tel:+250794776745"
                    className="text-blue-600 underline"
                  >
                    +250 794776745
                  </a>
                  <br />
                  Email:{" "}
                  <a
                    href="mailto:support@uplus.rw"
                    className="text-blue-600 underline"
                  >
                    support@uplus.rw
                  </a>
                </p>
              </section>
            </div>
          </>
        );
    }
  };

  return (
    <div className="min-h-screen bg-white dark:bg-defaultBlack dark:text-white text-defaultBlack">
      {/* Fixed Header */}
      <nav className="fixed top-0 left-0 right-0 px-6 py-4 flex items-center justify-between bg-teal-900 backdrop-blur-sm z-50">
        <div className="flex items-center">
          <Logo />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-4">
          <LanguageSwitcher />
          <ThemeToggle isNewDesign={true} />
        </div>

        {/* Mobile Menu Toggle */}
        <div className="md:hidden flex items-center">
          <button
            className="text-white focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="absolute top-16 left-0 w-full bg-teal-900 text-white flex flex-col items-start p-4 space-y-4 z-50">
            {/* Tab Links */}
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`block text-left px-4 py-2 w-full ${
                  activeTab === tab.id ? "bg-teal-700 font-medium" : ""
                }`}
              >
                {tab.label}
              </button>
            ))}

            {/* Language Switcher and Theme Toggle */}
            <div className="flex flex-col items-start space-y-4 mt-4">
              <LanguageSwitcher />
              <div className="flex items-center space-x-2">
                <ThemeToggle isNewDesign={true} />
                <span className="font-medium">
                  {isDarkMode ? "Dark" : "Light"} Mode
                </span>
              </div>
            </div>
          </div>
        )}
      </nav>

      <div className="fixed top-16 left-0 right-0  shadow z-10 bg-white dark:bg-defaultBlack">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="py-6 text-xl font-bold ">TERMS OF SERVICE</h1>
        </div>
      </div>

      {/* Main Content - Adjusted for fixed header */}
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pt-40 pb-8">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Sidebar Navigation - Conditional Rendering */}
          {isSidebarVisible && (
            <div className="w-full md:w-fit flex-shrink-0">
              <nav className="relative border-l border-gray-200 dark:border-gray-500/50 md:fixed flex flex-col">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => handleTabChange(tab.id)}
                    className={`block text-left px-4 py-3 relative hover:text-defaultGreen transition-colors
                      ${
                        activeTab === tab.id
                          ? "text-defaultGreen font-medium"
                          : " "
                      }
                      ${
                        activeTab === tab.id
                          ? "before:absolute before:left-0 before:top-0 before:bottom-0 before:w-0.5 before:bg-defaultGreen"
                          : ""
                      }
                    `}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>
          )}

          {/* Content Area - Scrollable */}
          <div className="flex-1 rounded-lg shadow p-6 lg:p-8 md:ml-[200px]">
            <div className="max-w-4xl">{renderContent()}</div>
          </div>
        </div>
      </div>
      <footer className="bg-[rgb(0,73,69)] text-white py-10 bg-radial-gradient-2 z-[100] relative">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0">
          {/* Logo & Description */}
          <div className="mb-8 md:mb-0">
            <Logo />
            <p className="text-sm max-w-xs mt-4">
              A digital group financing platform which enables people to pool
              funds together in a group.
            </p>
            {/* Social Icons */}
            <div className="flex space-x-6 mt-6">
              <a
                href="https://linkedin.com/company/uplus-mutual-partners/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-defaultYellow duration-150"
              >
                <LinkedinIcon className="w-7 h-7" />
              </a>
              <a
                href="https://facebook.com/UplusRw"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-defaultYellow duration-150"
              >
                <FacebookIcon className="w-7 h-7" />
              </a>
              <a
                href="https://twitter.com/Uplusrw"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-defaultYellow duration-150"
              >
                <TwitterIcon className="w-7 h-7" />
              </a>
              <a
                href="https://instagram.com/Uplusrw/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-defaultYellow duration-150"
              >
                <InstagramIcon className="w-7 h-7" />
              </a>
            </div>
          </div>

          {/* Links Sections */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-bold mb-3">Support</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/#" className="hover:text-yellow-500">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/#benefits" className="hover:text-yellow-500">
                    Benefits
                  </Link>
                </li>
                <li>
                  <Link to="/#products" className="hover:text-yellow-500">
                    Products
                  </Link>
                </li>
                <li>
                  <Link to="/#faqs" className="hover:text-yellow-500">
                    FAQs
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-3">Help</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/help-center" className="hover:text-yellow-500">
                    Help Center
                  </Link>
                </li>
                <li>
                  <Link
                    to="/terms-conditions"
                    className="hover:text-yellow-500"
                  >
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy" className="hover:text-yellow-500">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-3">Product</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/#products" className="hover:text-yellow-500">
                    Social CrowdFund
                  </Link>
                </li>
                <li>
                  <Link to="/#products" className="hover:text-yellow-500">
                    Ikimina
                  </Link>
                </li>
                <li>
                  <Link to="/#products" className="hover:text-yellow-500">
                    U-Save
                  </Link>
                </li>
                <li>
                  <Link to="/#products" className="hover:text-yellow-500">
                    U-Invest
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Download Buttons - Aligned Vertically */}
          <div className="hidden lg:block">
            <div className="flex flex-col space-y-4">
              <a
                href="https://apple.co/2KnmQCE"
                className="bg-white dark:bg-black dark:text-white px-3 py-3 rounded-lg flex items-center space-x-2 text-defaultBlack w-fit"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/App_Store_%28iOS%29.svg/2048px-App_Store_%28iOS%29.svg.png"
                  alt="App Store"
                  className="w-6 h-6"
                />
                <span>App Store</span>
              </a>
              <a
                href="http://bit.ly/uplusRW"
                className="bg-white dark:bg-black dark:text-white px-3 py-3 rounded-lg flex items-center space-x-2 text-defaultBlack w-fit"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Google_Play_Arrow_logo.svg/1024px-Google_Play_Arrow_logo.svg.png"
                  alt="Play Store"
                  className="w-6 h-6"
                />
                <span>Play Store</span>
              </a>
            </div>
          </div>
        </div>
        {/* Horizontal Divider */}
        <div className="w-3/4 mx-auto border-t border-white/50 mt-10"></div>

        {/* Footer Note */}
        <div className="text-center mt-6">
          <p className="text-sm">Uplus Mutual Partners Ltd. ©2025</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
